const schema = [
        ['user'],
        ['tenant'],
        ['role'],
        ['project'],
];

export default schema;
